import userApi from '@/api/user';

const UserAuth = {
  timeId: null,
  startDetectUserIsAlive: () => {
    if (UserAuth.timeId) return;
    UserAuth.timeId = setInterval(() => {
      userApi.isUserAuthLive();
      localStorage.setItem("lastOnBoardTime", new Date().getTime().toString());
    }, 10 * 1000);
  },

  stopDetectUserIsAlive: () => {
    clearInterval(UserAuth.timeId);
  },
};

export default UserAuth;
